namespace appn.views.taskTemplates.review {

    export function init(): void {
        addEvents();
    }

    function addEvents() {
        $(document).on('click', '.delete_button', function() {
            const presetIdx = $(this)?.closest('.fieldTable')?.attr('id')?.replace('fields_', appn.emptyString) ?? 0;
            const dataname = $(this).data('name');

            // enable the selected element
            $(`#addField_${presetIdx} option[value='${dataname}']`).prop('disabled', false);

            $(this).parents('tr').remove();
            renameRows((presetIdx as number));
        });

        $('.addField').on('change', function(event) {
            $('.helperText').remove();
            event.preventDefault();

            if ($(this).val() === '0')
                return;

            const presetIdx = $(this)?.attr('id')?.replace('addField_', appn.emptyString) ?? 0;
            const items = $(`#fields_${presetIdx} tbody`);
            const idx = items.children().length;
            const checkBoxId = `Template__Reviewables_${presetIdx}__Fields_${idx}__Required`;
            const checkBoxId2 = `Template__Reviewables_${presetIdx}__Fields_${idx}__Reviewable`;
            const thisVal = $(this).val();

            const newRow = `<tr><td>${thisVal}</td><td>${$(this).find('option:checked').data('qt')}</td><td class="dataCol"><input type="hidden"  name="Template.Reviewables[${presetIdx}].Fields[${idx}].DataName" id="Template__Reviewables_${presetIdx}__Fields_${idx}__DataName" value="${thisVal}"><input type="checkbox" name="Template.Reviewables[${presetIdx}].Fields[${idx}].Required" id=${checkBoxId} value="true"/></td><td class="text-right">${elementBuilder.buildBtnRemoveRow('delete_button', `data-name="${thisVal}"`)}</td></tr>`;

            $(`#fields_${presetIdx} tbody`).append(newRow);

            // disable the selected element
            $(`#addField_${presetIdx} option[value='${thisVal}']`).prop('disabled', true);

            // reset the selected index of the select list to the first index
            $(`#addField_${presetIdx}`).val('0');

            // apply the correct style to the generated checkbox input
        });

    }

    function renameRows(presetIdx: number) {
        // rename all remaining rows to keep continuous index
        let rowIdx = 0;
        $('#fields_' + presetIdx + ' tbody tr').each(function(index, row) {

            $(this).find('input').each(function(index, col) {
                let inputName = $(this).attr('name');
                let inputId = $(this).attr('id');

                inputName = inputName?.replace(/\.Fields\[[0-9]+\]\./, `.Fields[${rowIdx}].`) ?? appn.emptyString;

                $(this).attr('name', inputName);

                if (typeof inputId !== 'undefined') {
                    inputId = inputId.replace(/__Fields_[0-9]+__/, `__Fields_${rowIdx}__`);
                    $(this).attr('id', inputId);
                }
            });
            rowIdx++;
        });
    }

}
